// Logo officiel BizCoach AI — icône + wordmark extraits du brand-kit
// (linkedin-300-cream-stacked.svg). Icône recréée en SVG inline (net à toute
// taille) ; wordmark « BizCoach AI » (Inter, « AI » à 50 %). Adapté en
// horizontal pour la barre de menu. Le wordmark se masque sous `sm`.

interface BizCoachLogoProps {
  className?: string;
  /** Taille de l'icône (classe Tailwind). Défaut h-8 w-8. */
  iconClassName?: string;
  /** Afficher le wordmark « BizCoach AI ». Défaut true (masqué sous sm). */
  showWordmark?: boolean;
}

export function BizCoachLogo({ className, iconClassName = "h-8 w-8", showWordmark = true }: BizCoachLogoProps) {
  return (
    <span className={`flex items-center gap-2 ${className ?? ""}`}>
      {/* Icône officielle (viewBox 120, paths exacts du brand-kit) */}
      <svg viewBox="0 0 120 120" className={`${iconClassName} shrink-0`} aria-hidden="true">
        <rect width="120" height="120" rx="22" fill="#111111" />
        <path
          d="M60 14 C 65 44, 76 55, 106 60 C 76 65, 65 76, 60 106 C 55 76, 44 65, 14 60 C 44 55, 55 44, 60 14 Z"
          fill="#ffffff"
        />
        <circle cx="60" cy="60" r="6" fill="#FF5B14" />
      </svg>
      {showWordmark && (
        <span
          className="hidden shrink-0 whitespace-nowrap text-xl font-bold leading-none sm:inline-block"
          style={{ fontFamily: "Inter, system-ui, sans-serif", color: "#111111", letterSpacing: "-0.02em" }}
        >
          BizCoach<span style={{ fontWeight: 500, opacity: 0.5 }}> AI</span>
        </span>
      )}
    </span>
  );
}
